module.exports = __webpack_public_path__ + "img/jrsb.903d0c62.gif";